import { ReactComponent as ShortenLogo } from '../../assets/imgs/logo_kn.svg'

export default ShortenLogo
